import { Component, OnInit } from '@angular/core';

import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-campus',
    templateUrl: './campus.component.html',
    styleUrls: ['./campus.component.scss']
})
export class CampusComponent implements OnInit {

    public campus: Campus;
    public webResourceId: string = "campus-page";

    constructor(private campusService: CampusService) { }

    ngOnInit() {

        this.campus = this.campusService.campusActive;

    }
}
